module.exports = __webpack_public_path__ + "img/_members.c369c0ad.svg";